// extracted by mini-css-extract-plugin
module.exports = {"goBackButton":"SignIn_goBackButton__37Wm1"};